import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import qs from 'qs'
import router from '@/router'

// 是否显示重新登录
export const isRelogin = { show: false }
console.log('process.env.VUE_APP_BASE_URL', process.env)
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  transformRequest: [
    function(data, headers) {
      if (headers['Content-Type'] === 'application/x-www-form-urlencoded') {
        // 把一个参数对象格式化为一个字符串
        return qs.stringify(data)
      } else if (
        headers['Content-Type'] === 'multipart/form-data;charset=UTF-8'
      ) {
        return data
      } else {
        headers['Content-Type'] = 'application/json'
      }
      return JSON.stringify(data)
    }
  ],
  timeout: 8000
  // withCredentials:true
})
axios.defaults.withCredentials = true

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // console.log("config",config)
    config.headers['Authorization'] = localStorage.getItem('token')
    return config
  },
  (error) => {
    // 请求前出错做些什么
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data
    // console.log(response)
    if (res.code == 200) {
      // 请求成功后将数据返回
      return Promise.resolve(res.data)
    }
    if (res.code == 401) {
      if (!isRelogin.show) {
        isRelogin.show = true
        MessageBox.confirm(
          '登录状态已过期，您可以继续留在该页面，或者重新登录',
          '系统提示',
          {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
          .then(() => {
            isRelogin.show = false
            store.dispatch('user/resetToken').then(() => {
              location.href = '/login'
            })
          })
          .catch(() => {
            isRelogin.show = false
          })
      }
      return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
    } else {
      return Promise.reject(res.message)
    }
  },
  (error) => {
    console.log('err' + error) // for debug
    Message.error(error.message)
    return Promise.reject(error)
  }
)

export default service
